function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.125 0C27.3571 0 27.5796 0.0921874 27.7437 0.256282C27.9078 0.420376 28 0.642936 28 0.875V14.875C28 15.1071 27.9078 15.3296 27.7437 15.4937C27.5796 15.6578 27.3571 15.75 27.125 15.75C26.8929 15.75 26.6704 15.6578 26.5063 15.4937C26.3422 15.3296 26.25 15.1071 26.25 14.875V9.191L15.2827 15.554C14.3727 16.0825 13.125 15.4788 13.125 14.336V9.191L2.15775 15.554C1.24775 16.0825 0 15.4788 0 14.336V1.414C0 0.27125 1.24775 -0.3325 2.15775 0.196L13.125 6.559V1.414C13.125 0.27125 14.3727 -0.3325 15.2827 0.196L26.25 6.559V0.875C26.25 0.642936 26.3422 0.420376 26.5063 0.256282C26.6704 0.0921874 26.8929 0 27.125 0V0ZM1.75 1.98275V13.7672L11.907 7.875L1.75 1.98275ZM14.875 1.98275V13.7672L25.032 7.875L14.875 1.98275Z",
  fill: "black"
});

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.4a088e97.svg";
export { ForwardRef as ReactComponent };